"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _toPairs = _interopRequireDefault(require("lodash/toPairs"));

var _fromPairs = _interopRequireDefault(require("lodash/fromPairs"));

var _zip = _interopRequireDefault(require("lodash/zip"));

var _mathUtils = require("../../util/mathUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function formatLabels(data) {
  // Convert to list of key-value pairs
  var pairs = (0, _toPairs.default)(data); // Convert from decimal fractions to percentages

  var percentages = pairs.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        item = _ref2[1];

    return item.value * 100;
  }); // Round to integers

  var rounded;

  if (percentages.length === 4) {
    // When full data set (4 labels) ensure their rounded values sum to 100...
    rounded = (0, _mathUtils.largestRemainderRound)(percentages, 100);
  } else {
    // ... Otherwise do regular rounding
    rounded = percentages.map(function (v) {
      return Math.round(v);
    });
  } // Convert to percentage strings


  var formatted = rounded.map(function (value) {
    return "".concat(value, "%");
  }); // Collect in object with original keys

  var newPairs = (0, _zip.default)(pairs, formatted).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        _ref4$ = _slicedToArray(_ref4[0], 1),
        key = _ref4$[0],
        value = _ref4[1];

    return [key, value];
  });
  return (0, _fromPairs.default)(newPairs);
}

var DataLabels = function DataLabels(_ref5) {
  var theme = _ref5.theme,
      scales = _ref5.scales,
      data = _ref5.data,
      show = _ref5.show,
      hatched = _ref5.hatched,
      inverted = _ref5.inverted;
  if (!data) return null;
  var north = scales.north,
      east = scales.east,
      south = scales.south,
      west = scales.west;
  var padding = 10;
  var font = {
    fontFamily: theme.font3,
    fontSize: 14,
    fill: inverted ? theme.inverted.one[0] : theme.one[0],
    fontWeight: '900'
  };
  var bgStroke = {
    strokeWidth: '7px',
    // This allows the text to be read clearly over darker/hatched background
    stroke: theme.tertiary
  };
  var formatted = formatLabels(data);
  var labels = [];
  var bgLabels = [];

  if (show.north) {
    var position = {
      x: show.east ? east(0) + padding : west(0) - padding,
      y: north(data.north.value) - padding,
      textAnchor: show.east ? 'start' : 'end',
      alignmentBaseline: 'baseline'
    };
    var content = formatted.north;
    bgLabels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      key: "northBg"
    }, bgStroke, font, position), content));
    labels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      className: "north",
      key: "north"
    }, font, position), content));
  }

  if (show.east) {
    var _position = {
      x: east(data.east.value) + padding,
      y: show.south ? south(0) + padding : north(0) - padding,
      textAnchor: 'start',
      alignmentBaseline: show.south ? 'hanging' : 'baseline'
    };
    var _content = formatted.east;
    bgLabels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      key: "eastBg"
    }, bgStroke, font, _position), _content));
    labels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      className: "east",
      key: "east"
    }, font, _position), _content));
  }

  if (show.south) {
    var _position2 = {
      x: show.west ? west(0) - padding : east(0) + padding,
      y: south(data.south.value) + padding,
      textAnchor: show.west ? 'end' : 'start',
      alignmentBaseline: 'hanging'
    };
    var _content2 = formatted.south;
    bgLabels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      key: "southBg"
    }, bgStroke, font, _position2), _content2));
    labels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      className: "south",
      key: "south"
    }, font, _position2), _content2));
  }

  if (show.west) {
    var _position3 = {
      x: west(data.west.value) - padding,
      y: show.north ? north(0) - padding : south(0) + padding,
      textAnchor: 'end',
      alignmentBaseline: show.north ? 'baseline' : 'hanging'
    };
    var _content3 = formatted.west;
    bgLabels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      key: "westBg"
    }, bgStroke, font, _position3), _content3));
    labels.push( /*#__PURE__*/_react.default.createElement("text", _extends({
      className: "west",
      key: "west"
    }, font, _position3), _content3));
  }

  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, hatched ? /*#__PURE__*/_react.default.createElement("g", null, bgLabels) : null, /*#__PURE__*/_react.default.createElement("g", null, labels));
};

var dataItemPropType = _propTypes.default.shape({
  name: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired
});

DataLabels.propTypes = {
  scales: _propTypes.default.shape({
    north: _propTypes.default.func.isRequired,
    east: _propTypes.default.func.isRequired,
    south: _propTypes.default.func.isRequired,
    west: _propTypes.default.func.isRequired
  }).isRequired,
  data: _propTypes.default.shape({
    north: dataItemPropType,
    east: dataItemPropType,
    south: dataItemPropType,
    west: dataItemPropType
  }).isRequired,
  show: _propTypes.default.shape({
    north: _propTypes.default.bool,
    east: _propTypes.default.bool,
    south: _propTypes.default.bool,
    west: _propTypes.default.bool
  }),
  inverted: _propTypes.default.bool
};
DataLabels.defaultProps = {
  show: {
    north: true,
    east: true,
    south: true,
    west: true
  },
  inverted: false
};

var _default = (0, _styledComponents.withTheme)(DataLabels);

exports.default = _default;
//# sourceMappingURL=DataLabels.js.map